import React from "react";
import classes from "./PosReceipt.module.css";
import HeaderNav from "../../Components/Dahboard Header/HeaderNav/HeaderNav";
import Footer from "../../Components/Footer/Footer";
import { useLocation, useNavigate } from "react-router-dom";

const PosReceipt = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const modeFromQuery = searchParams.get("mode");
  const modeFromState = location.state?.mode;
  const { result } = location.state || {};
  const isPOS = (modeFromState || modeFromQuery || "pos") === "pos";

  const {
    company,
    currency,
    customer_id,
    invoice_number,
    created_at,
    description,
    sales = [],
    sub_total,
    total_discount,
    total_vat,
    total_wht,
    total_price,
    transaction_date,
  } = result || {};

  if (!location.state) {
    return (
      <div className={classes.errorPage}>
        <h2>Invoice data not found.</h2>
        <button onClick={() => navigate("/dashboard")}>Go to Dashboard</button>
      </div>
    );
  }

  console.log(result);

  const fmtMoney = (n) => {
    const num = Number(n || 0);
    try {
      const code = currency?.symbol;
      return new Intl.NumberFormat(undefined, { style: "currency", currency: code }).format(num);
    } catch {
      return `${currency?.symbol ?? ""}${num.toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
    }
  };

  const StarRule = () => (
    <div className={classes.starRule} aria-hidden="true">
      {Array.from({ length: 44 }).map(() => "*").join("")}
    </div>
  );

  const printInvoice = () => {
    window.print();
  };

  return (
    <div>
      <HeaderNav className={classes.noPrint} />
      <div className={classes.page}>
        <button onClick={printInvoice} className={`${classes.printBtn} ${classes.noPrint}`}>
          🖨 Print
        </button>
       <div className={`${classes.paper} printSheet`}>
          <header className={classes.header}>
            <h1 className={classes.shopName}>{company?.name || "SHOP NAME"}</h1>
            <div className={classes.muted}>
              {company?.address && <div>{company.address}</div>}
              {company?.phone_number && <div>Tel: {company.phone_number}</div>}
            </div>
            <div style={{ marginTop: 10 }} />
            <StarRule />
            <div className={classes.title}>CASH RECEIPT</div>
            <StarRule />
          </header>
          <section className={classes.meta}>
            <div className={classes.metaRow}>
              <span className={classes.metaLabel}>Receipt #</span>
              <span className={classes.metaValue}>{invoice_number}</span>
            </div>
            <div className={classes.metaRow}>
              <span className={classes.metaLabel}>Date</span>
              <span className={classes.metaValue}>{transaction_date}</span>
            </div>
            {customer_id && (
              <div className={classes.metaRow}>
                <span className={classes.metaLabel}>Customer</span>
                <span className={classes.metaValue}>{customer_id}</span>
              </div>
            )}
          </section>
          <StarRule />
          <section className={classes.items}>
            <table className={classes.table}>
              <colgroup>
                <col className={classes.colItem} />
                <col className={classes.colPrice} />
                <col className={classes.colAmount} />
              </colgroup>
              <thead>
                <tr>
                  <th>Item</th>
                  <th>Price</th>
                  <th style={{ textAlign: "right" }}>Amount</th>
                </tr>
              </thead>
              <tbody>
                {sales.map((s, idx) => {
                  const name = s?.item?.name ?? `Item ${idx + 1}`;
                  const qty = Number(s?.quantity || 0);
                  const unitPrice = Number(s?.item?.price || 0);
                  const lineTotal = Math.max(unitPrice * qty, 0);
                  return (
                    <tr key={s.id || idx}>
                      <td>
                        <span className={classes.truncate}>{qty}x {name}</span>
                      </td>
                      <td>
                        <span className={`${classes.truncate} ${classes.num}`}>{fmtMoney(unitPrice)}</span>
                      </td>
                      <td style={{ textAlign: "right" }}>
                        <span className={`${classes.truncate} ${classes.num}`}>{fmtMoney(lineTotal)}</span>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
            

          </section>
          <StarRule />
          <section className={classes.totals}>
            <div className={classes.totalRow}><span>Discount</span><span>{fmtMoney(total_discount)}</span></div>
            <div className={classes.totalRow}><span>Subtotal</span><span>{fmtMoney(sub_total)}</span></div>
            <div className={classes.totalRow}><span>VAT</span><span>{fmtMoney(total_vat)}</span></div>
            <div className={classes.totalRow}><span>WHT</span><span>{fmtMoney(total_wht)}</span></div>
            <div className={`${classes.totalRow} ${classes.grand}`}><span>Total</span><span>{fmtMoney(total_price)}</span></div>
          </section>
          <StarRule />
          <footer className={classes.footer}>
            <div className={classes.thanks}>THANK YOU!</div>
          </footer>
        </div>
      </div>
      <div className={classes.noPrint}><Footer /></div>
    </div>
  );
};

export default PosReceipt;